module.exports = __webpack_public_path__ + "static/img/step-3.d99b1cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/free-trial/step-3.png
// module id = XyB5
// module chunks = 1